export const BARCODE_COLUMN = "barcode";
export const FIXED_BARCODE_COLUMN = "fixed_barcode";